<div *ngIf="formerTdaIra; else notFormerTdaIra" class="cash-title" data-testid="formerTdaTooltip">
    <mm-tooltip [position]="'right'" [containsLink]="false" [textTooltip]="true">
        <tooltip-content>
            <span [innerText]="formerTdaIraVerbiage" data-testid="formerTdaTooltipVerbiage"></span>
            <span slot="tooltip-content"><br><br><a href="https://veoone.tdainstitutional.com/#!/auth/login"
                    target="_blank">
                    <div class="combine-hyperlink">Go to Veo One<sdps-icon color="active" type="functional"
                            name="external" size="small" class="veo-one-external-icon"></sdps-icon></div>
                </a></span>
        </tooltip-content>
        <tooltip-trigger-element>
            <span [innerText]="balance.type" id="ytdLabel"></span>
            <sdps-icon id="ira-warning-icon" color="warning" type="functional" name="warning" size="small"></sdps-icon>
        </tooltip-trigger-element>
    </mm-tooltip>

</div>
<ng-template #notFormerTdaIra>
    <div class="cash-title">{{ balance.type }}
        <mm-tooltip *ngIf="displayTooltip" [position]="'right'" [containsLink]="false"
            id="accountInfoHeader_cashBalanceTooltip">
            <tooltip-content>
                <div>{{tooltipVerbiage}}</div>
            </tooltip-content>
            <tooltip-trigger-element>
                <sdps-icon color="active" type="functional" name="info" size="small"></sdps-icon>
            </tooltip-trigger-element>
        </mm-tooltip>
    </div>
</ng-template>
<div data-testid="balance-amount" [ngClass]="cashBalanceClass">{{ isNumber(balance.amount) ? (balance.amount | currency) : balance.amount }}</div>
